// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Keycloak from 'keycloak-js';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import VueKonva from 'vue-konva';
import VueLogger from 'vuejs-logger';
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
import App from './App';
import Store from './store';
import setupRouter from './router';
import { KEYCLOAK_CLIENT_ID, SSO_API_BASE } from './env';
import './utils/filters';

const resizeObserverLoopMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

function isResizeObserverLoopMessage(message) {
  return resizeObserverLoopMessages.includes(message);
}

window.addEventListener('error', (event) => {
  if (isResizeObserverLoopMessage(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason && event.reason.message;
  if (isResizeObserverLoopMessage(message)) {
    event.preventDefault();
  }
});

Vue.use(ElementUI, { locale });
Vue.use(VueLogger);
Vue.use(VueKonva);

const router = setupRouter();

const initOptions = {
  url: SSO_API_BASE,
  realm: 'Readyspaces',
  clientId: KEYCLOAK_CLIENT_ID,
  onLoad: 'login-required',
};

const keycloak = Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
  if (auth) {
    Sentry.init({
      Vue,
      dsn: 'https://29216661042c42529de69e6887e7119e@o1028018.ingest.sentry.io/4504960069468160',
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: ['epoch.readyspaces.com', 'portal.api.readyspaces.com', /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
    // eslint-disable-next-line no-new
    new Vue({
      el: '#app',
      render: h => h(App, { props: { keycloak } }),
      router,
      data: Store,
    });
  } else {
    keycloak.login({ redirectUri: this.$route.toPath() });
  }

  // Token Refresh
  setInterval(() => {
    keycloak.updateToken(70).then((refreshed) => {
      if (refreshed) {
        Vue.$log.info(`Token refreshed${refreshed}`);
        Vue.prototype.$keycloak = keycloak;
      } else {
        Vue.$log.warn(`Token not refreshed, valid for ${
          // eslint-disable-next-line no-mixed-operators
          Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000)} seconds`);
      }
    }).catch(() => {
      Vue.$log.error('Failed to refresh token');
    });
  }, 60000);
}).catch(() => {
  Vue.$log.error('Authenticated Failed');
});

Vue.prototype.$keycloak = keycloak;
Vue.config.productionTip = false;

/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js